export const aiAssistantsListSelector = state => {
  const { aiAssistant } = state
  if (!aiAssistant) return []

  const results = aiAssistant.get('results')
  const order = aiAssistant.get('orderAssistants')

  if (!results || !order) return []

  return order
    .map(id => results.get(id.toString()))
    .filter(Boolean)
    .map(item => item.toJS())
}

export const aiAssistantsCountSelector = state => state.aiAssistant?.get('count') || 0

export const aiAssistantsPageSelector = state => state.aiAssistant?.get('page') || 0

export const aiAssistantsFilterSelector = state => state?.aiAssistant?.get('filter')?.toJS()

export const aiAssistantsPageSizeSelector = state => state.aiAssistant?.get('pageSize') || 10

export const aiAssistantsParamsSelector = state => state.aiAssistant?.get('params') || {}

export const aiAssistantsIsAscSelector = state => state.aiAssistant?.get('isAsc')

export const aiAssistantsNextSelector = state => state.aiAssistant?.get('next')

export const getAiAssistantByIdSelector = id => state =>
  state.aiAssistant?.getIn(['results', id?.toString()]) || null

export const aiCorrectionsListSelector = state => {
  const { aiCorrections } = state
  if (!aiCorrections) return []

  const results = aiCorrections.get('results')
  const order = aiCorrections.get('order')
  const count = aiCorrections.get('count') || 0

  if (!results || !order) return { results: [], count }

  const parsedResults = order
    .map(id => results.get(id.toString()))
    .filter(Boolean)
    .map(item => item.toJS())

  return {
    results: parsedResults,
    count,
  }
}

export const aiModelsListSelector = state => {
  const { aiModels } = state
  if (!aiModels) return []

  const results = aiModels.get('results')
  const order = aiModels.get('order')

  if (!results || !order) return []

  return order
    .map(id => results.get(id.toString()))
    .filter(Boolean)
    .map(item => item.toJS())
}
